import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-piechart',
  templateUrl: './piechart.component.html',
  styleUrls: ['./piechart.component.css']
})
export class PieChartComponent {

  @Output()
  clicked = new EventEmitter<string>();

  @Output()
  ready = new EventEmitter<void>();

  @Input()
  public pieChartLabels: string[] = ['Chrome', 'Safari', 'Firefox', 'Internet Explorer', 'Other'];

  @Input()
  public pieChartData: number[] = [40, 20, 20 , 10, 10];

  @Input()
  public pieChartType: string = 'pie';
  // events
  public chartClicked(e: any): void {
    this.clicked.emit(e.active[0]._model.label);
  }

  public chartHovered(e: any): void {
  //  console.log(e);
  }

}
